module.exports = __webpack_public_path__ + "f4720195dc25370aaaa6613a4c6c9769.pdf";